<template>
	<div class="container" v-if="coupon">

		<header class="container__header">

			<div class="settings">

				<h1 v-text="coupon.title"></h1>

				 <ws-dropdown v-if="!coupon.deleted_at">

					<template slot="thumb">	<i class="fas fa-cog icon--sm dark-grey"></i></template>

					<template slot="content">

						<ul>
							<li><router-link :to="{name:'coupon.edit', params:{coupon:coupon.id}}"><i class="fas fa-pencil-alt"></i> Rediger</router-link></li>
							<li><a href="#" @click.prevent="doShowDeleteModal"><i class="fas fa-trash-alt"></i> Slet</a></li>
							<!--<li>
								<a href="#" @click.prevent="doShowActivationModal" :class="{'disabled':!option.may_delete}" :disabled="!option.may_delete">
									<template v-if="!option.active"><i class="fas fa-eye"></i> Aktiver</template>
									<template v-else><i class="fas fa-eye-slash"></i> Deaktiver</template>
								</a>
							</li>-->
						</ul>

					</template>

				</ws-dropdown>

			</div>

			<h3 v-if="coupon.deleted_at === null">Status: Aktiv</h3>
			<h3 v-else>Status: Inaktiv</h3>

		</header>

		<div class="container__body container__body--lg">

			<header class="col-12 margin-b-50 flex--space">

				<h1>Statistik</h1>

				<div class="datepicker">

					<a href="#" @click.prevent="showDatePickerModal = true"><i class="icon--md fas fa-calendar-alt"></i> {{dateRangeText}}</a>

				</div>

			</header>

			<main class="stats">

                <section class="item">

                    <h1><animate-number
                        :from="old_total_uses_in_regular"
                        :to="stats.total_uses_in_regular"
                        duration="2000"
                        easing="easeInOutCirc"
                        mode="manual"
                        ref="totalUsesInRegular">
                    </animate-number><span>stk</span>
                    </h1>

                    <h2>Antal rabatkuponner <br> Mad ud af huset</h2>

                    <p>Det totale rabatkuponer brugt for Mad ud af huset, i den valgte tidsperiode.</p>

                </section>

                <section class="item">

                    <h1> <animate-number
                        :from="old_total_uses_in_custom"
                        :to="stats.total_uses_in_custom"
                        duration="2000"
                        easing="easeInOutCirc"
                        mode="manual"
                        ref="totalUsesInCustom">
                    </animate-number><span>stk</span>
                    </h1>

                    <h2>Antal rabatkuponner <br> Nytårsmenu</h2>

                    <p>Det totale rabatkuponer brugt for Nytårsmenu, </br> i den valgte tidsperiode.</p>

                </section>

				<section class="item">

					<h1> <animate-number
							:from="old_total_discount_in_regular"
							:to="stripeAmount(stats.total_discount_in_regular).amountForEditing"
							duration="2000"
							easing="easeInOutCirc"
							mode="manual"
							ref="totalDiscountInRegular">
						</animate-number><span>kr</span>
					</h1>

					<h2>Rabat <br> Mad ud af huset</h2>

					<p>Den totale rabat givet for Mad ud af huset, </br> i den valgte tidsperiode.</p>

				</section>

				<section class="item">

					<h1> <animate-number
							:from="old_total_discount_in_custom"
							:to="stripeAmount(stats.total_discount_in_custom).amountForEditing"
							duration="2000"
							easing="easeInOutCirc"
							mode="manual"
							ref="totalDiscountInCustom">
						</animate-number><span>kr</span>
					</h1>

                    <h2>Rabat <br> Nytårsmenu</h2>

                    <p>Den totale rabat givet for Nytårsmenu, </br> i den valgte tidsperiode.</p>

				</section>


			</main>

		</div>

		<ws-modal v-model="showDeleteModal">

			<div class="modal-wrap">

				<div class="modal--sm center">

					<span class="close" @click.prevent="showDeleteModal = false"><i class="fas fa-times"></i></span>

					<i class="fas fa-trash-alt icon--lg margin-b-25"></i>

					<h1>Slet Tilvalg</h1>

					<h2>Er du sikker på du vil slette {{coupon.title}}?</h2>

					<h3>Du kan ikke fortryde denne handling!</h3>

					<div class="col-12 margin-t-25">

						<a class="btn btn--sm btn--primary primary--copper" href="#" @click.prevent="deleteCoupon">Ja tak</a>

						<a href="#" @click.prevent="showDeleteModal = false">Nej tak!</a>

					</div>

				</div>

			</div>

		</ws-modal>

		<ws-modal v-model="showDatePickerModal">

			<div class="modal-wrap">

				<div class="modal--sm center">

					<span class="close" @click.prevent="datePickerReset"><i class="fas fa-times"></i></span>

					<div class="datepicker-trigger"   id="datepicker-trigger">
						<AirbnbStyleDatepicker
								:trigger-element-id="'datepicker-trigger'"
								:inline="true"
								:mode="'range'"
								:date-one="dateStartForDatePicker"
								:date-two="dateEndForDatePicker"
								:showActionButtons="false"
								:monthsToShow="1"
								@date-one-selected="setStartDate"
								@date-two-selected="setEndDate"
						/>
					</div>

				</div>

			</div>

		</ws-modal>

		<!--<ws-modal v-model="showActivationModal">

			<div class="modal-wrap">

				<div class="modal&#45;&#45;sm center">

					<span class="close" @click.prevent="showActivationModal = false"><i class="fas fa-times"></i></span>

					<i class="fas fa-trash-alt icon&#45;&#45;lg margin-b-25"></i>

					<h1 v-if="!option.active">Aktiver Produkt</h1>
					<h1 v-else>Deaktiver Produkt</h1>

					<h2 v-if="!option.active">Er du sikker på du vil aktivere {{option.title}}?</h2>
					<h2 v-else>Er du sikker på du vil deaktivere {{option.title}}?</h2>

					<div class="col-12 margin-t-25">

						<a class="btn btn&#45;&#45;sm btn&#45;&#45;primary primary&#45;&#45;copper" href="#" @click.prevent="optionActivation">Ja tak</a>

						<a href="#" @click.prevent="showActivationModal = false">Nej tak!</a>

					</div>

				</div>

			</div>

		</ws-modal>-->

	</div>
</template>

<script>
	import {format} from 'date-fns';
	import da from 'date-fns/locale/da';
    export default {
        name: "coupon-stats",
        data() {
            return {
                coupon:null,
				stats:null,
				showDeleteModal:false,
				showDatePickerModal:false,
			/*	showActivationModal:false,*/
                dateStartForDatePicker:'',
                dateEndForDatePicker:'',
				dateStart:'',
				dateEnd:'',
				format,
                old_total_uses_in_regular:0,
                old_total_discount_in_regular:0,
                old_total_uses_in_custom:0,
                old_total_discount_in_custom:0,
			};
        },
		computed:{
          	dateRangeText(){
          	  	if(this.dateStart === '' && this.dateEnd === ''){
          	  	    return 'Vælg datoer'
				}
				let startDate = this.format(this.dateStart, 'MMMM DD, YYYY', {locale:da});
          	  	let endDate = this.format(this.dateEnd, 'MMMM DD, YYYY', {locale:da})
				return startDate.charAt(0).toUpperCase() + startDate.slice(1) + ' - ' + endDate.charAt(0).toUpperCase() + endDate.slice(1);
			},
		},
        methods: {
            getCoupon(){
                axios.get(`/api/admin/coupon/${this.$route.params.coupon}/stats`).then(response => {
                    this.coupon = response.data.data.coupon;
                    this.stats = response.data.data.stats;
                    setTimeout(()=>{
                        this.$refs.totalDiscountInRegular.start();
                        this.$refs.totalUsesInRegular.start();
                        this.$refs.totalDiscountInCustom.start();
                        this.$refs.totalUsesInCustom.start();
					}, 500);
				});
			},
			getCouponStatsByRange(){
                axios.post(`/api/admin/coupon/${this.$route.params.coupon}/stats`,{
                    start: this.dateStart,
					end: this.dateEnd,
				}).then(response => {
                    this.old_total_uses_in_regular = this.stats.total_uses_in_regular;
                    this.old_total_discount_in_regular = this.stats.total_discount_in_regular;
                    this.old_total_uses_in_custom = this.stats.total_uses_in_custom;
                    this.old_total_discount_in_custom = this.stats.total_discount_in_custom;
                    this.old_total_number_of_orders = this.stats.total_number_of_orders;

                    this.coupon = response.data.data.coupon;
                    this.stats = response.data.data.stats;

                    setTimeout(()=>{
                        this.$refs.totalDiscountInRegular.reset(this.stripeAmount(this.old_total_discount_in_regular).amountForEditing, this.stripeAmount(this.stats.total_discount_in_regular).amountForEditing);
                        this.$refs.totalUsesInRegular.reset(this.old_total_uses_in_regular, this.stats.total_uses_in_regular);
                        this.$refs.totalDiscountInCustom.reset(this.stripeAmount(this.old_total_discount_in_custom).amountForEditing, this.stripeAmount(this.stats.total_discount_in_custom).amountForEditing);
                        this.$refs.totalUsesInCustom.reset(this.old_total_uses_in_custom, this.stats.total_uses_in_custom);


                        this.$refs.totalDiscountInRegular.start();
                        this.$refs.totalUsesInRegular.start();
                        this.$refs.totalDiscountInCustom.start();
                        this.$refs.totalUsesInCustom.start();
                    }, 500);
                });
			},
			revenueFormatter(num){
                num = this.stripeAmount(num).amountForEditing;
                return num > 999 ? (num/1000).toFixed(0) + 'k' : num.toFixed(0);
			},
			deleteCoupon(){
                axios.delete(`/api/admin/coupon/${this.$route.params.coupon}`).then(()=>{
                    this.$router.replace({
                        name:'coupon.index',
                    })
				});
			},
			setStartDate(val){
                this.dateStartForDatePicker = val;
			},
			setEndDate(val){
                this.dateStart = this.dateStartForDatePicker;
				this.dateEnd = val;
				this.getCouponStatsByRange();
				this.datePickerReset()
			},
			datePickerReset(){
                this.showDatePickerModal = false;
                this.dateStartForDatePicker = '';
                this.dateEndForDatePicker = '';
			},
           /* optionActivation(){
                if(!this.option.may_delete){
                    return;
                }

                if(!this.option.active){
                    axios.put(`/api/admin/option/${this.option.id}/activate`).then(response=>{
                        this.showActivationModal = false;
                        this.getOption();
                    });
                }else{
                    axios.put(`/api/admin/option/${this.option.id}/deactivate`).then(response=>{
                        this.showActivationModal = false;
                        this.getOption();
                    });
                }

            },*/
			doShowDeleteModal(){
                this.showDeleteModal = true;
			},
           /* doShowActivationModal(){
                if(!this.option.may_delete){
                    return;
                }
                this.showActivationModal = true;
            }*/
		},
		created(){
			this.getCoupon();
		}
    }
</script>

<style scoped>

</style>
